import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { Card, CardProps } from "@/libraries/design/components/card/src/card";
import { wacToken } from "@/libraries/design/foundations";
import { Row } from "@/libraries/wpl/foundations/src";

const pageSection = css({
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%",
    clear: "both",
    backgroundColor: wacToken("color.neutral.light0"),
    position: "relative"
});

const sectionCss = css({
    paddingBlockStart: token("space.400"),
    paddingBlockEnd: token("space.800"),
    position: "relative",
    verticalAlign: "baseline",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%"
});
const headerStyle = css({
    textAlign: "center",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    h2: {
        color: wacToken("color.extended.blue900"),
        fontWeight: "500",
        padding: "16px 0",
        lineHeight: " 1.33333333",

        [media.below.sm]: {
            margin: "0 0 14px",
            fontSize: token("space.300")
        },

        [media.only.sm]: {
            margin: "0",
            fontSize: "2.25rem"
        },

        [media.above.md]: {
            margin: "0",
            fontSize: "2.25rem"
        }
    }
});

const cardContainer = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".illustrationImageContainer > img": {
        width: "75px"
    }
});

const GetTheMostSection = () => {
    const intl = useIntl();
    const cardData = [
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceHeaderText",
                defaultMessage: "Tailor to your team’s needs"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceBodyText",
                defaultMessage:
                    "Extend your Atlassian products with thousands of apps from Marketplace."
            }),
            callToAction: {
                href: "https://marketplace.atlassian.com/",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.marketplacePrimaryLink",
                    defaultMessage: "Go to Marketplace"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl:
                "https://wac-cdn.atlassian.com/dam/jcr:76e94ebd-d71e-4991-9008-7b2e838090c8/illustrations-spot-Integrations.svg?cdnVersion=2999"
        },
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityHeaderText",
                defaultMessage: "Train with Atlassian University"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityBodyText",
                defaultMessage:
                    "Develop new skills, improve your team’s work, and advance your professional career."
            }),
            callToAction: {
                href: "https://www.atlassian.com/university",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.universityPrimaryLink",
                    defaultMessage: "Go to Atlassian University"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl:
                "https://wac-cdn.atlassian.com/dam/jcr:a88ae3d8-e6fd-4428-8a14-c9ce6b460b0e/illustrations-spot-Atlassian%20Book_1.svg?cdnVersion=2999"
        }
    ] as CardProps[];

    return (
        <section css={sectionCss}>
            <div css={pageSection}>
                <Row>
                    <div css={headerStyle}>
                        <h2>
                            <FormattedMessage
                                id="TryPageTemplate.getTheMost.header"
                                defaultMessage="Get the most out of your products"
                            />
                        </h2>
                    </div>
                </Row>
                <Row layout="6-6">
                    {cardData.map((card, index) => (
                        <div css={cardContainer} key={index}>
                            <Card {...card} />
                        </div>
                    ))}
                </Row>
            </div>
        </section>
    );
};

export default GetTheMostSection;
